import React from 'react'
import { FaTelegramPlane } from 'react-icons/fa'
import { FaXTwitter } from 'react-icons/fa6'

export default function Footer() {
  return <footer className='px-[10vw] py-[5vw] mt-10 relative'>
    <div className='grid md:grid-cols-2 grid-cols-1 gap-10 relative z-50'>
      <div className='space-y-5'>
        <img src="/images/logo.png" alt="" className='md:w-[15vw] w-[50vw]' />
        <p className='md:text-base text-sm'>Agent DORA is the Onchain Agnostic AI Agent of Griffain Engine, fondly called as the Google of Griffain, for its effective On-Chain agnostic search and trading.
        </p>

      </div>
      <div className='grid  grid-cols-2  gap-10'>
        <div>
          <h2 className='text-xl'>Company</h2>
          <div className='flex  flex-col md:gap-5 gap-3 flex-wrap opacity-80 md:text-lg text-sm mt-5'>
            <a href="#Home" className='block'>Features</a>
            <a href="#About" className='block'>About</a>
            <a href="#Tokenomics" className='block'>Tokenomics</a>
            <a href="#Roadmap" className='block'>Roadmap</a>
          </div>
        </div>
        <div className='flex items-center flex-col'>
          <h2 className='text-xl'>Socials</h2>
          <div className='flex items-center md:gap-5 gap-3 flex-wrap opacity-80 md:text-lg text-sm mt-5'>
            <a href="">
              <FaXTwitter />
            </a>
            <a href="">
              <FaTelegramPlane />
            </a>
          </div>
        </div>
      </div>

    </div >
    <hr className='border-gray-500 my-5' />
    <p className='text-gray-500 text-center'>Copyright © 2025 Agent Dora. All Rights Reserved</p>
    <img src="/images/footer-layar.png" alt="" className='absolute bottom-0 left-0 w-full z-30 ' />
  </footer >
}  
